// @flow
import { Icon } from 'semantic-ui-react';
import React from 'react';

export const EstimatesViewIcon = () => <Icon fitted={true} name="hockey puck" />;
